// extracted by mini-css-extract-plugin
export default {"icon":"LockOn_icon__7sWo4"};